var React = require('react');

function RetirableListIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z","fill":"#26313B","key":0}),React.createElement("path",{"d":"M19.0776 18.9589H10.6475V27.389H19.0776V18.9589Z","fill":"#C2F0E7","key":1}),React.createElement("path",{"d":"M28.4783 17.9788V9.56094C23.83 9.56094 20.0604 13.3305 20.0574 17.9788H28.4783Z","fill":"#FDC097","key":2}),React.createElement("path",{"d":"M19.0714 9.58247H10.6536C10.6536 14.2307 14.4232 18.0003 19.0714 18.0034V9.58247Z","fill":"white","key":3})]);
}

RetirableListIconInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = RetirableListIconInline;

RetirableListIconInline.default = RetirableListIconInline;
